// Modules
import { useCallback } from "react";

// Redux
import { categoriesSelector } from "redux/categories/categoriesSlice";
import {
	activeFiltersSelector,
	removeSortedSelectedFilter,
	sortedSelectedFiltersSelector,
	urlPathSelector
} from "redux/filters/filtersSlice";
import {useAppDispatch, useAppSelector } from "redux/hooks";

// Hooks
import useRouting from "hooks/useRouting";

// Types
import { Category } from "interfaces/category";

// Utils
import { getNextUrl } from "utils/queryString";
import { findMacroCategory } from "utils/categories";

const ChosenFilters = (): JSX.Element[] => {
	const dispatch = useAppDispatch();
	const sortedSelectedFilters = useAppSelector(sortedSelectedFiltersSelector);
	const activeFilters = useAppSelector(activeFiltersSelector);
	const urlPath = useAppSelector(urlPathSelector);
	const categories = useAppSelector(categoriesSelector);
	const pushNewRoute = useRouting();

	const removeFilter = useCallback(
		(macroCategory: Category, tagToRemove: Category) => {
			if (sortedSelectedFilters) {
				dispatch(removeSortedSelectedFilter(tagToRemove));

				const activeMacroCategory = activeFilters.filter((activeFilter) => activeFilter.macroCategory.id === macroCategory.id)[0];
				const updatedSelectedTags = activeMacroCategory.selectedTags.filter((tag) => tag.id !== tagToRemove.id);
				const nextUrl = getNextUrl(macroCategory, updatedSelectedTags, urlPath, categories);
				pushNewRoute(nextUrl);
			}
		},
		[activeFilters, urlPath, categories]
	);

	const filterElements: JSX.Element[] = [];
	if (sortedSelectedFilters) {
		sortedSelectedFilters.forEach((tag) => {
			const macroCategory = findMacroCategory(tag, categories);
			filterElements.push(<ChooseFilter key={tag.id} macroCategory={macroCategory} tag={tag} removeFilter={removeFilter} />);
		});
	}
	return filterElements;
};

export default ChosenFilters;

interface ChooseFilterProps {
	macroCategory: Category;
	tag: Category;
	removeFilter: (macroCategory: Category, tagToRemove: Category) => void;
}

const ChooseFilter = ({ macroCategory, tag, removeFilter }: ChooseFilterProps) => {
	return (
		<div className="wk-choosen-filter">
			<button className="wk-icon-close"  onClick={() => removeFilter(macroCategory, tag)}></button>
			<span className="wk-choosen-filter-label">{macroCategory.name.toUpperCase()}</span>
			<span>: {tag.name.toUpperCase()}</span>
		</div>
	);
};
